import { Form } from 'react-bootstrap';
import 'filepond/dist/filepond.min.css';
import { useEffect, useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop
);

export default function FileUploader({
  label,
  setFile,
  maxFiles,
  isCleared,
  isBase64 = false,
  allowCrop = false,
  defaultImages = [],
  allowReorder = false,
  allowMultiple = false,
  allowTransform = false,
}) {
  const [media, setMedia] = useState([]);

  function getBase64(media) {
    if ((!allowMultiple && media) || (allowMultiple && media.length > 0)) {
      var reader = new FileReader();
      if (allowMultiple) {
        Promise.all(
          media.map(
            (image) =>
              new Promise((resolve, reject) => {
                var reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = (file) => {
                  resolve(file.target.result.split(',')[1]);
                };
                reader.onerror = (error) => reject(error);
              })
          )
        ).then((base64Images) => {
          setFile(base64Images);
        });
      } else {
        reader.readAsDataURL(media);
        reader.onload = function () {
          if (allowMultiple) {
            setFile((prevState) => [...prevState, reader.result]);
          } else {
            setFile(reader.result);
          }
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      }
    }
  }

  useEffect(() => {
    if (allowMultiple) {
      isBase64 ? getBase64(media) : setFile(media);
    } else {
      isBase64 ? getBase64(media[0]) : setFile(media[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media]);

  useEffect(() => {
    isCleared && setMedia([]);
  }, [isCleared]);

  return (
    <Form.Group>
      {label && <Form.Label>{label}</Form.Label>}
      <FilePond
        credits={false}
        files={media}
        onupdatefiles={(fileItems) => {
          setMedia(fileItems.map((fileItem) => fileItem.file));
          setFile(fileItems.map((fileItem) => fileItem.file));
        }}
        // server="/api"
        maxFiles={maxFiles}
        allowImageCrop={allowCrop}
        allowReorder={allowReorder}
        allowMultiple={allowMultiple}
        allowImageTransform={allowTransform}
        imageCropAspectRatio={allowCrop ? '1:1' : null}
        name='files'
        labelIdle={
          '.فایل خود را در اینجا رها کنید یا روی <span class="filepond--label-action">آپلود فایل</span> کلیک کنید'
        }
      />
    </Form.Group>
  );
}
